<section id="edit-dotation" *ngIf="load.closed">
  <h2>{{ article.designation }}</h2>
  <section id="changement-taille">
    <h3>Modifications des références du vêtement</h3>
    <article>
      <form [formGroup]="editDotationForm">
        <div class="flex justify-between items-center">
          <label>Change hebdomadaire</label>
          <mat-form-field>
            <mat-select [(value)]="selected" placeholder="Sélectionner un change">
              <mat-option *ngFor="let change of changes"
                [value]="change.qte_semaine+'/'+change.qte_prevue+'|'+change.multi_change+':'+change.type_facturation.cle_ref">{{change.qte_semaine}}/{{change.qte_prevue}}
                ({{change.type_facturation.cle_ref}})</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div *ngIf="facturationTypeSB()" class="flex justify-between items-center">
          <label>Quantité souhaitée *</label>
          <mat-form-field>
            <mat-select [(value)]="selected_value" placeholder="Quantité souhaitée" formControlName="qteSouhaite">
              <mat-option [value]=1>1</mat-option>
              <mat-option [value]=2>2</mat-option>
              <mat-option [value]=3>3</mat-option>
              <mat-option [value]=4>4</mat-option>
              <mat-option [value]=5>5</mat-option>
              <mat-option [value]=6>6</mat-option>
              <mat-option [value]=7>7</mat-option>
              <mat-option [value]=8>8</mat-option>
              <mat-option [value]=9>9</mat-option>
              <mat-option [value]=10>10</mat-option>
              <mat-option [value]=11>11</mat-option>
            </mat-select>
            <mat-error *ngIf="editDotationForm.get('qteSouhaite').hasError('required')">Vous devez renseigner la
              quantité souhaitée</mat-error>
          </mat-form-field>
        </div>
        <p>Quantité hebdomadaire <strong>{{article.change}}</strong> / stock <strong>{{article.stock}}</strong>
          ({{article.type_facturation}})</p>
        <div class="flex justify-between items-center;">
          <span>Taille actuelle : <strong>{{article.taille}}</strong></span>
          <div class="taille flex items-center">
            <label>Nouvelle taille : </label>
            <mat-icon (click)="dec()" class="icon-click">remove_circle_outline</mat-icon>
            <strong>{{taille}}</strong>
            <mat-icon (click)="inc()" class="icon-click">add_circle_outline</mat-icon>
          </div>
        </div>
        <div id="precision">
          <mat-form-field>
            <textarea id="inputPrecision" #inputPrecision matInput rows="5" placeholder="Commentaire"
              (input)="changePrecision($event)" [value]="article.precision ?? ''"></textarea>
          </mat-form-field>
        </div>
      </form>

      <div class="actions"
        *ngIf="!(taille === article.taille && article.change + '/' + article.stock === selected && precision === undefined)">
        <button mat-raised-button (click)="reset()" color="white">Annuler</button> <button mat-raised-button
          (click)="demandeChangement()">Enregistrer</button>
      </div>
    </article>
  </section>
  <section id="track">
    <h3>Traçabilité du vêtement</h3>
    <article>
      <table mat-table [dataSource]="dataSource">
        <ng-container *ngFor="let column of columns">
          <ng-container matColumnDef="{{column.id}}">Chan
            <th mat-header-cell *matHeaderCellDef>{{ column.libelle }}</th>
            <td mat-cell *matCellDef="let element">{{ element[column.id] }}</td>
          </ng-container>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </article>
  </section>
</section>